import React from 'react'
import Navbar from '../components/layout/newNavbar'
function SinglePost(props) {

    console.log(props.viewPost)
    return (
        <div>
            <Navbar />
            <div>

            </div>
        </div>
    )
}

export default SinglePost
